import { c as _c } from "react/compiler-runtime";
import EditIcon from '@mui/icons-material/EditOutlined';
import { type Theme, styled } from '@mui/material';
export const Edit = t0 => {
  const $ = _c(4);
  const {
    onClick,
    muted
  } = t0;
  if (muted) {
    let t1;
    if ($[0] !== onClick) {
      t1 = <MutedIcon onClick={onClick} />;
      $[0] = onClick;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let t1;
  if ($[2] !== onClick) {
    t1 = <PrimaryIcon onClick={onClick} />;
    $[2] = onClick;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const MutedIcon = styled(EditIcon, {})(({
  theme
}: {
  theme: Theme;
}) => ({
  cursor: 'pointer',
  color: theme.palette.grey[400]
}));
const PrimaryIcon = styled(EditIcon, {})(({
  theme
}: {
  theme: Theme;
}) => ({
  cursor: 'pointer',
  color: theme.palette.primary.main
}));